import { render, staticRenderFns } from "./EditDriver.vue?vue&type=template&id=0385ab32&"
import script from "./EditDriver.vue?vue&type=script&lang=js&"
export * from "./EditDriver.vue?vue&type=script&lang=js&"
import style0 from "./EditDriver.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports